import { render, staticRenderFns } from "./Compass_.vue?vue&type=template&id=dfd93818&scoped=true&"
import script from "./Compass_.vue?vue&type=script&lang=ts&"
export * from "./Compass_.vue?vue&type=script&lang=ts&"
import style0 from "./Compass_.vue?vue&type=style&index=0&id=dfd93818&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfd93818",
  null
  
)

export default component.exports